'use client';

import { c as _c } from "react/compiler-runtime";
import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';
import { getStoreById } from '@libs/api-proxy-client';
export const storeQueryFactory = (storeId?: string) => queryOptions({
  queryKey: ['store', storeId],
  queryFn: storeId ? () => getStoreById(storeId) : skipToken,
  // staleTime – keep cache 10 minutes - data is considered fresh for 10 minutes,
  // and during this period, reusing the cache will not fetch new data.
  staleTime: 10 * 60 * 1000
});
export const useStoreQuery = storeId => {
  const $ = _c(2);
  let t0;
  if ($[0] !== storeId) {
    t0 = storeQueryFactory(storeId);
    $[0] = storeId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};